import { api, ui } from "../interfaces/interfaces";
import { useEffect } from 'react';

const getAvailabilityForCurrentJobAddress = async () => await api.fetchServiceAgreementsAvailability({
    "boilerAge": 0,
    "postcode": ui.PropertyAddressPostcode,
    "jobTypeCode": ui.ProblemComboJob?.jobTypeCode
});

export const useGetAvailabilityForCurrentJobAddress = () => {
    useEffect(() => {
        getAvailabilityForCurrentJobAddress();
    }, [])
}